/**
 * How reports are bucketed on the Reports page and its drawer. Each registry entry declares its own
 * group — `reportTypes` in `api/registry.ts`, `ediphiReportTemplates` in `templates/registry.ts` —
 * so a report's section is a property of the report, not a lookup table kept alongside it.
 */
export type ReportGroup = "estimate" | "gcgr" | "contracting" | "other";

export const REPORT_GROUP_ORDER: ReportGroup[] = ["estimate", "gcgr", "contracting", "other"];

/**
 * Groups items in `REPORT_GROUP_ORDER`, dropping groups nothing falls into. Shared by the reports
 * page and its drawer so the two can't order or group differently.
 */
export const groupByReportGroup = <T>(
  items: T[],
  groupOf: (item: T) => ReportGroup | undefined
): { type: ReportGroup; items: T[] }[] =>
  REPORT_GROUP_ORDER.map((type) => ({ type, items: items.filter((item) => groupOf(item) === type) })).filter(
    (group) => group.items.length > 0
  );
